import React from "react";
import Hero from "../Components/Hero";
import CTA from "../Components/CTA";
import About from "../Components/About";
import Features from "../Components/Features";
import HowItWorks from "../Components/HowItWorks";
import Info from "../Components/Info";
import WhyNad from "../Components/WhyNad";
import Analytics from "../Components/Analytics";
import Privacy from "../Components/Privacy";
import FAQ from "../Components/FAQ";

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <Hero  />

      {/* CTA Section */}
      <CTA  />

      {/* ABOUT SECTION */}
      <About  />

      {/* FEATURES SECTION */}
      <Features  />

      {/* HOW IT WORKS SECTION */}
      <HowItWorks />

      {/* Info SECTION */}
      <Info/>

      {/* WhyNadSECTION */}
      <WhyNad  />

      {/* Analytics SECTION */}
      <Analytics  />

      {/* FAQ SECTION */}
      <FAQ />

      {/* Privacy SECTION */}
      <Privacy  />
    </div>
  );
};

export default Home;
